import { profileQueryHttp } from '../../_shared/infrastructure/profile-query.http';
import type { TrackedLpsGateway } from './tracked-lps.gateway';

/**
 * Tracked LPs → the shared profile read pinned to the favourites scope, matching
 * the original `useInfiniteApi('/profiles?favorite=true')` request shape.
 */
export const httpTrackedLpsGateway: TrackedLpsGateway = {
  fetchProfiles: (params) => profileQueryHttp.fetchProfiles({ ...params, favorite: true }),
};
